import "./style.css"
// skeleton variants: 'text' | 'circular' | 'rectangular' | 'rounded'

interface SkeletonBaseProps {
    variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
    width?: string;
    height?: string;
    className?: string;
    style?: React.CSSProperties;
}

const SkeletonBase: React.FC<SkeletonBaseProps> = ({
    variant = 'text',
    width = '100%',
    height = '1em',
    className = '',
    style,
}) => {
    const skeletonClasses = `Skeleton Skeleton-${variant} ${className}`;

    return (
        <div
            className={skeletonClasses}
            style={{
                width,  
                height,
                ...style,
            }}
        />
    );
};

export default SkeletonBase